import { render, staticRenderFns } from "./EhsDashboardTable.vue?vue&type=template&id=5b758682&scoped=true"
import script from "./EhsDashboardTable.vue?vue&type=script&lang=js"
export * from "./EhsDashboardTable.vue?vue&type=script&lang=js"
import style0 from "./EhsDashboardTable.vue?vue&type=style&index=0&id=5b758682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b758682",
  null
  
)

export default component.exports